var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "all") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "All"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 34.98,
    width: 23.91,
    height: 23.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.05,
    y: 34.98,
    width: 23.91,
    height: 23.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.09,
    y: 34.98,
    width: 23.91,
    height: 23.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 71.12,
    width: 23.91,
    height: 23.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.05,
    y: 71.12,
    width: 23.91,
    height: 23.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 86.09,
    y: 71.12,
    width: 23.91,
    height: 23.91
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/all.a400e98f87fec9210c8556e149d5367e.svg";
export { ForwardRef as ReactComponent };